// eslint-disable-next-line
import React, { Component } from "react";
import { connect } from "react-redux";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Components
import SignUpForm from "./../components/SignUpForm";

//Deps
import { push } from "react-router-redux";
import { withStyles } from "@material-ui/core/styles";

function mapStateToProps(state) {
  return {
    advancedSignUp: state.app.advancedSignUp,
    isAuth: state.user.auth !== null,

    //Form Values
    email: state.forms.signUp.email,
    name: state.forms.signUp.name,
    password: state.forms.signUp.password,
    passwordConfirm: state.forms.signUp.passwordConfirm,
    dbErrors: state.forms.errors.hasErrors,

    //Form State
    pending: state.forms.forms.signUp.$form.pending,
    submitted: state.forms.forms.signUp.$form.submitted,
    submitFailed: state.forms.forms.signUp.$form.submitFailed,
    validating: state.forms.forms.signUp.$form.validating,

    emailIsValid: state.forms.forms.signUp.email.valid,
    formIsValid: state.forms.forms.signUp.$form.valid,
    passwordIsValid: state.forms.forms.signUp.password.valid,
    passwordConfirmIsValid: state.forms.forms.signUp.passwordConfirm.valid,

    //Errors
    emailErrors: state.forms.forms.signUp.email.errors,
    formErrors: state.forms.forms.signUp.$form.errors,
    passwordErrors: state.forms.forms.signUp.password.errors,
    passwordConfirmErrors: state.forms.forms.signUp.passwordConfirm.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    //Routing
    routeHome: () => dispatch(push("home")),
    routeReset: () => dispatch(push("reset")),

    //Form Submit
    handleSubmit: val =>
      dispatch({
        type: ACTIONS.SUBMIT_SIGNUP,
        meta: {
          model: "forms.signUp",
          payload: val
        }
      }),

    //Advanced Form Toggle
    handleToggle: (val, e) => {
      dispatch({
        type: ACTIONS.TOGGLE_ADVANCED_SIGNUP,
        payload: e
      });
    },

    //If already logged in
    routeToProfile: () => {
      dispatch(push("profile"));
    }
  };
}

//Styles
const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: "2em"
  }
});

class SignUpPage extends Component {
  componentDidMount() {
    const { isAuth, routeToProfile } = this.props;
    return isAuth ? routeToProfile() : null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <h3 style={{ padding: "1em 0" }}>SIGN UP</h3>
        <SignUpForm model="forms.signUp" {...this.props} />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SignUpPage));



// WEBPACK FOOTER //
// ./src/pages/SignUpPage.js